// Добавляем полифиллы для совместимости с Node.js модулями
import { Buffer } from 'buffer';
import process from 'process';
import React, { lazy, Suspense } from "react"; // ⭐ ИЗМЕНЕНО: Добавлены lazy и Suspense
import ReactDOM from "react-dom/client";
import "./index.css";
import './i18n';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { createGlobalStyle } from 'styled-components';
import { AuthContextProvider } from "./context/AuthContext";
// ⭐ ИЗМЕНЕНО: Все страницы теперь импортируются "лениво"
const Home = lazy(() => import('./pages/Home'));
const ErrorCom = lazy(() => import('./Components/ErrorCom'));
const Boost = lazy(() => import('./pages/Boost'));
const Wallet = lazy(() => import('./pages/Wallet'));
const TasksList = lazy(() => import('./pages/Tasks'));
const GoldHunters = lazy(() => import('./pages/GoldHunters'));
const Mine = lazy(() => import('./pages/Mine'));
const History = lazy(() => import('./pages/History'));
const DaiABPheckIn = lazy(() => import('./pages/Checkin'));
const Levels = lazy(() => import('./Components/Levels'));
const Inventory = lazy(() => import('./pages/RepairPage'));
const UpgradePage = lazy(() => import('./pages/UpgradePage'));
const BossFightPage = lazy(() => import('./pages/BossFightPage'));
const Dayl = lazy(() => import('./pages/day'));
const ForgePage = lazy(() => import('./pages/ForgePage'));
// ... другие импорты
const CelestialClashPage = lazy(() => import('./pages/CelestialClashPage'));

// ...
// Другие страницы, если они есть



// Полифиллы
window.Buffer = Buffer;
window.process = process; // Оставили только одну строку

if (typeof global === 'undefined') {
  window.global = window;
}

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 13px;
  }
`;

if (window.Telegram && window.Telegram.WebApp) {
  const tg = window.Telegram.WebApp;
  tg.ready();
  tg.expand();
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorCom />,
    children:[
      { path:"/", element: <GoldHunters /> },
      { path:"/inventory", element: <Inventory /> },
      { path:"/forge", element: <ForgePage /> },
      { path:"/upgrade", element: <UpgradePage /> },
      { path:"/Checkin", element: <DaiABPheckIn /> },
      { path:"/day", element: <Dayl /> },
      { path:"/levels", element: <Levels showLevel={true} /> },
      { path:"/mine", element: <Mine /> },
      { path: "/BossFightPage", element: <BossFightPage /> },
      { path:"/history", element: <History /> },
      { path:"/tasks", element: <TasksList /> },
      { path:"/referral", element: <TasksList startIndex={3} /> },
      { path:"/boost", element: <Boost /> },
      { path:"/wallet", element: <Wallet /> },
      { path:"/celestial-clash", element: <CelestialClashPage /> }, 
    ]
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthContextProvider>
    <React.StrictMode>
      <GlobalStyle />
      {/* ⭐ ИЗМЕНЕНО: RouterProvider обернут в Suspense */}
      <Suspense fallback={
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#0d0c1d'
    }}>
      <img src="/loader.png" alt="Loading page..." style={{width: '100px'}} />
    </div>
  }>
    <RouterProvider router={router} />
  </Suspense>
    </React.StrictMode>
  </AuthContextProvider>
);